// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box } from '@mui/system';
import OverflowTooltipText from 'Components/OverflowTooltipText';
import ReferenceIdEditor from 'Components/ReferenceIdEditor';
import { formatProjectDate, PROJECT_VALUE_UNSET } from 'Utils/projectDisplay';
import stylesDef from './styles';

/* eslint-disable react/require-default-props */
interface IProjectReferenceLineProps {
  projectId: string;
  referenceId?: string;
  // When given, the line also says when the project was created, after the reference.
  createdAt?: string;
  // The host's type for the line (a card footer, a row's meta text, a pin card's row).
  sx?: object;
}
/* eslint-enable react/require-default-props */

// A project's reference, editable in place (AUT-6449), on every surface that shows one: the
// dashboard's rows and cards, the map rail's cards and the pin card. The surfaces are cards and
// rows that drag and open on click; nothing the editor is given - a press, a drag, a key - may
// reach them, or typing an id would file the project or leave for its page.
const stop = (event: React.SyntheticEvent) => event.stopPropagation();

export const ProjectReferenceLine = ({ projectId, referenceId, createdAt, sx }: IProjectReferenceLineProps) => {
  const styles = stylesDef();

  return (
    // Not interactive itself: it only keeps its children's events from the card it sits in.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <Box
      sx={[styles.root, sx ?? {}]}
      onPointerDown={stop}
      onPointerUp={stop}
      onClick={stop}
      onKeyDown={stop}
    >
      <Box component="span" sx={styles.label}>REF:</Box>
      <ReferenceIdEditor projectId={projectId} referenceId={referenceId} emptyText={PROJECT_VALUE_UNSET} addPrompt={PROJECT_VALUE_UNSET} />
      {createdAt && (
        <Box className="projectReferenceCreated" sx={styles.created}>
          <OverflowTooltipText text={`| Created on ${formatProjectDate(createdAt)}`} sx={styles.created} />
        </Box>
      )}
    </Box>
  );
};

export default ProjectReferenceLine;
